import { create } from 'zustand'

type FilterKeys =
  | 'TREG'
  | 'Regional_Tsel'
  | 'Tipe_Site'
  | 'Mitra'
  | 'Frekuensi'
  | 'Status_Redeploy'
  | 'Status_Material'

interface FilterState {
  TREG: string
  Regional_Tsel: string
  Tipe_Site: string
  Mitra: string
  Frekuensi: string
  Status_Redeploy: string
  StatusMaterial: string

  setFilter: (key: FilterKeys, value: string) => void
  resetFilters: () => void
}

export const useFilterStore = create<FilterState>((set) => ({
  TREG: '',
  Regional_Tsel: '',
  Tipe_Site: '',
  Mitra: '',
  Frekuensi: '',
  Status_Redeploy: '',
  StatusMaterial: '',

  setFilter: (key, value) =>
    set((state) => ({
      ...state,
      [key]: value,
    })),

  resetFilters: () =>
    set({
      TREG: '',
      Regional_Tsel: '',
      Tipe_Site: '',
      Mitra: '',
      Frekuensi: '',
      Status_Redeploy: '',
      StatusMaterial: '',
    }),
}))
